import styled from "styled-components";

export const GridContainer = styled.div`
  background-color: rgb(3, 21, 31);
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100vw;
`;
export const PatternsContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  overflow-y: scroll;
`;
export const GridText = styled.div`
  color: ${(props) => props.theme.primary};
  font-weight: 600;
  margin-top: 50px;
  white-space: nowrap;
`;
export const PatternHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 50px;
  width: 100%;
`;
